import { render, staticRenderFns } from "./LaasonSM.vue?vue&type=template&id=505b8364&scoped=true&"
import script from "./LaasonSM.vue?vue&type=script&lang=js&"
export * from "./LaasonSM.vue?vue&type=script&lang=js&"
import style0 from "./LaasonSM.vue?vue&type=style&index=0&id=505b8364&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505b8364",
  null
  
)

export default component.exports